import * as React from "react";
import Image from "next/image";
const LogoWithImage = ({
  src,
  alt = "EcoVadis Logo",
  width = 73.344,
  height = 25.728,
  ...props
}) => {
  // Calculate center position for the image area
  const centerX = 86.5; // SVG width/2 (173/2)
  const centerY = 86.5; // SVG height/2 (173/2)
  // Calculate foreignObject position to center the image
  const foreignObjectX = centerX - width / 2;
  const foreignObjectY = centerY - height / 2;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={173}
      height={173}
      fill="none"
      {...props}
    >
      <rect
        width={147.639}
        height={147.639}
        x={12.359}
        y={13}
        fill="#F8FAFF"
        rx={73.82}
      />
      <rect
        width={147.639}
        height={147.639}
        x={12.359}
        y={13}
        stroke="#F8FAFF"
        strokeOpacity={0.6}
        strokeWidth={24.607}
        rx={73.82}
      />
      <rect
        width={108.269}
        height={108.269}
        x={32.266}
        y={32.594}
        fill="#fff"
        rx={54.134}
      />
      <foreignObject
        x={foreignObjectX}
        y={foreignObjectY}
        width={width}
        height={height}
      >
        {src && (
          <Image
            src={src}
            alt={alt}
            width={width}
            height={height}
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        )}
      </foreignObject>
    </svg>
  );
};
export default LogoWithImage;
